export default {
    userAttestations(state) {
        return state.userAttestations
    }
}
